(() => {
  const root = document.querySelector("[data-lilpillo-home]");
  if (!root) return;

  const shop = root.querySelector("[data-product-shop]");
  const cards = shop
    ? Array.from(shop.querySelectorAll("[data-product-card]"))
    : [];
  const filterButtons = shop
    ? Array.from(shop.querySelectorAll("[data-product-filter]"))
    : [];
  const filterStatus = shop ? shop.querySelector("[data-filter-status]") : null;

  const labelForFilter = {
    all: "all pillows",
    mini: "Mini pillows",
    full: "Full Size pillows",
    large: "Large pillows",
    "no-down": "feather-free pillows",
    adaptive: "adjustable pillows",
  };

  const normaliseSize = (size) => {
    const normalised = String(size || "").trim().toLowerCase().replace(/\s+/g, "-");
    return normalised === "full-size" ? "full" : normalised;
  };

  const applyFilter = (filter) => {
    let visibleCount = 0;
    cards.forEach((card) => {
      const preferences = (card.dataset.preferences || "").split(" ");
      const matches =
        filter === "all" ||
        normaliseSize(card.dataset.size) === normaliseSize(filter) ||
        preferences.includes(filter);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });
    filterButtons.forEach((button) =>
      button.setAttribute(
        "aria-pressed",
        String(button.dataset.productFilter === filter),
      ),
    );
    if (filterStatus)
      filterStatus.textContent = `Showing ${visibleCount} ${labelForFilter[filter] || "pillows"}.`;
  };

  filterButtons.forEach((button) =>
    button.addEventListener("click", () =>
      applyFilter(button.dataset.productFilter),
    ),
  );
  root.querySelectorAll("[data-shop-filter]").forEach((link) => {
    link.addEventListener("click", () => {
      applyFilter(link.dataset.shopFilter);
      window.requestAnimationFrame(() =>
        shop
          ?.querySelector(`[data-product-filter="${link.dataset.shopFilter}"]`)
          ?.focus(),
      );
    });
  });

  const finder = root.querySelector("[data-height-finder]");
  const finderForm = finder?.querySelector("[data-height-form]");
  const finderResult = finder?.querySelector("[data-height-result]");

  const invalidateFinder = () => {
    if (!finderResult) return;
    const prompt = document.createElement("p");
    prompt.textContent = "Select “Show pillows to compare” to see your results.";
    finderResult.replaceChildren(prompt);
  };
  finderForm?.querySelector('input[name="height"]')?.addEventListener("input", invalidateFinder);
  finderForm?.querySelectorAll('input[name="preference"]').forEach((input) =>
    input.addEventListener("change", invalidateFinder),
  );

  const categorySelection = (sizes, preferences) => {
    const params = new URLSearchParams();
    const names = { mini: "Mini", full: "Full Size", large: "Large" };
    sizes.forEach((size) => params.append("filter.p.m.custom.pillow_size", names[size]));
    if (preferences.includes("no-down")) params.set("filter.p.m.custom.feather_or_down", "No feather or down");
    if (preferences.includes("no-latex")) params.set("filter.p.m.custom.latex", "No latex");
    return {
      href: `${window.Shopify?.routes?.root || "/"}collections/childrens-pillows?${params}`,
      exact: preferences.every((preference) => ["no-down", "no-latex"].includes(preference)),
    };
  };

  const createFinderLink = (card) => {
    const link = document.createElement("a");
    link.href = card.dataset.url;
    link.textContent = `${card.dataset.title} · ${card.dataset.price}${card.dataset.available === "true" ? "" : " · Sold Out"}`;
    if (card.dataset.available !== "true") link.dataset.unavailable = "true";
    return link;
  };

  finderForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    const height = Number(new FormData(finderForm).get("height"));
    if (!Number.isFinite(height) || height <= 0) return;

    let sizes = window.LilPilloSizes.recommend(height).sizes;
    let explanation = "";
    if (height < 92) {
      explanation =
        "Below 92 cm, LilPillo does not make an automatic size recommendation. Compare the current bed and pillow, then use parent or carer judgement.";
    } else if (height < 116) {
      explanation =
        "Mini is the first size to compare: it gives a smaller sleeping surface and is easier to pack.";
    } else if (height <= 128) {
      explanation =
        "Mini and Full Size both overlap here. Mini is more compact; Full Size gives more sleeping surface.";
    } else if (height < 152) {
      explanation =
        "Full Size is the first size to compare: more sleeping surface than Mini without the footprint of Large.";
    } else if (height === 152) {
      explanation =
        "Full Size and Large meet at 152 cm. Full Size is more compact; Large gives a standard UK pillow footprint and takes more space.";
    } else if (height <= 190) {
      explanation =
        "Large is the first size to compare. It gives a standard UK pillow footprint and takes real space in bed and luggage.";
    } else {
      explanation =
        "Above 190 cm, LilPillo does not make an automatic size recommendation. Compare the bed, current pillow and desired sleeping surface.";
    }

    const preferences = Array.from(
      finderForm.querySelectorAll('input[name="preference"]:checked'),
      (input) => input.value,
    );
    const matchingCards = cards.filter((card) => {
      if (!sizes.includes(normaliseSize(card.dataset.size))) return false;
      if (!preferences.length) return true;
      const cardPreferences = (card.dataset.preferences || "").split(" ");
      const exclusions = preferences.filter((preference) =>
        ["no-down", "no-latex"].includes(preference),
      );
      const styles = preferences.filter((preference) =>
        !["no-down", "no-latex"].includes(preference),
      );
      return exclusions.every((preference) => cardPreferences.includes(preference)) &&
        (!styles.length || styles.some((preference) => cardPreferences.includes(preference)));
    });

    finderResult.replaceChildren();
    const heading = document.createElement("h3");
    heading.textContent = "Sizes to compare";
    const copy = document.createElement("p");
    copy.textContent = explanation;
    finderResult.append(heading, copy);

    if (matchingCards.length) {
      const links = document.createElement("div");
      links.className = "lp-finder-options";
      matchingCards.forEach((card) => links.append(createFinderLink(card)));
      finderResult.append(links);
    } else if (sizes.length && preferences.length) {
      const noMatch = document.createElement("p");
      noMatch.textContent =
        "No current pillow matches those selected priorities together. Remove a preference to compare the available options for this size.";
      finderResult.append(noMatch);
    }
    if (sizes.length) {
      const selection = categorySelection(sizes, preferences);
      const categoryLink = document.createElement("a");
      categoryLink.href = selection.href;
      categoryLink.className = "lp-primary-action";
      categoryLink.textContent = selection.exact ? "Shop these pillows" : "Browse these sizes";
      if (!selection.exact) {
        const caveat = document.createElement("p");
        caveat.textContent = matchingCards.length
          ? "Your feel preference is shown in the product suggestions above."
          : "Browse these sizes without the feel preference; any feather/down or latex exclusions you selected still apply.";
        finderResult.append(caveat);
      }
      finderResult.append(categoryLink);
    }
    finderResult.focus({ preventScroll: true });
    finderResult.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
      block: "center",
    });
  });

  const cartStatus = root.querySelector("[data-cart-status]");
  const cartDrawer = root.querySelector("[data-home-cart]");
  const cartDrawerContent = root.querySelector("[data-home-cart-content]");
  const cartDrawerStatus = root.querySelector("[data-home-drawer-status]");
  let cartOpener = null;
  let savedOverflow = "";
  let statusTimer;
  const announceCart = (message) => {
    if (!cartStatus) return;
    window.clearTimeout(statusTimer);
    cartStatus.textContent = message;
    statusTimer = window.setTimeout(() => {
      cartStatus.textContent = "";
    }, 2800);
  };

  const closeCartDrawer = () => {
    if (cartDrawer?.open) cartDrawer.close();
  };

  const openCartDrawer = (trigger) => {
    if (!cartDrawer) return;
    cartOpener = trigger;
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    cartDrawer.showModal();
    cartDrawer.querySelector("[data-home-cart-close]")?.focus({ preventScroll: true });
  };

  const refreshCartDrawer = async () => {
    if (!cartDrawerContent) return;
    const target = new URL(`${window.Shopify?.routes?.root || "/"}cart`, window.location.origin);
    target.searchParams.set("section_id", "lp-collection-cart");
    const current = new URL(window.location.href);
    if (current.searchParams.has("preview_theme_id")) {
      target.searchParams.set("preview_theme_id", current.searchParams.get("preview_theme_id"));
    }
    const response = await fetch(target, {
      headers: { Accept: "text/html" },
      signal: AbortSignal.timeout(15000),
    });
    if (!response.ok) throw new Error("The basket display could not refresh.");
    const doc = new DOMParser().parseFromString(await response.text(), "text/html");
    doc.querySelectorAll("noscript").forEach((element) => element.remove());
    const body = doc.querySelector("[data-lp-cart]");
    if (!body) throw new Error("The basket display could not refresh.");
    cartDrawerContent.replaceChildren(body);
    window.LilPilloCart.init(body, { onRefresh: refreshCartDrawer });
    if (cartDrawerStatus) cartDrawerStatus.textContent = "";
  };

  cartDrawer?.addEventListener("close", () => {
    document.documentElement.style.overflow = savedOverflow;
    if (cartOpener?.isConnected) cartOpener.focus({ preventScroll: true });
  });
  cartDrawer?.addEventListener("keydown", (event) => {
    if (event.key !== "Tab") return;
    const items = Array.from(
      cartDrawer.querySelectorAll("a[href],button,input,select,textarea,[tabindex]"),
    ).filter((item) => !item.disabled && item.tabIndex >= 0 && item.getClientRects().length);
    const first = items[0];
    const last = items[items.length - 1];
    if (!first) {
      event.preventDefault();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  cartDrawer?.addEventListener("click", (event) => {
    if (event.target.closest("[data-home-cart-close]")) closeCartDrawer();
    else if (event.target === cartDrawer) closeCartDrawer();
  });

  root.querySelectorAll("[data-lp-product-form], [data-lp-catalog-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      if (!window.fetch || !window.LilPilloCart) return;
      event.preventDefault();
      const button = form.querySelector("[data-lp-add-button], [data-lp-catalog-add]");
      if (button.disabled || window.LilPilloCart.pending) return;
      const originalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "Adding…";
      let added = false;
      let uncertain = false;
      try {
        const payload = await window.LilPilloCart.add(form);
        added = true;
        button.textContent = "Added";
        button.dataset.added = "true";
        announceCart(`${payload.product_title || "Pillow"} added to your bag.`);
        openCartDrawer(button);
        await window.LilPilloCart.refresh();
        await refreshCartDrawer();
      } catch (error) {
        if (added) {
          announceCart("Added to your bag. The basket display could not refresh; your item has not been added again.");
          if (cartDrawerStatus) cartDrawerStatus.textContent = "Your item was added. Open the full basket to see it; do not repeat the addition.";
        } else {
          uncertain = !error.rejected;
          announceCart(
            uncertain
              ? "We could not confirm whether this item was added. Check your bag before trying again."
              : error.message || "This pillow could not be added.",
          );
        }
      } finally {
        button.removeAttribute("aria-busy");
        button.disabled = uncertain;
        button.textContent = uncertain ? "Check bag first" : originalLabel;
        delete button.dataset.added;
      }
    });
  });
})();

// Keep the family film optional, quiet, and respectful of an explicit pause.
(() => {
  function initFamilyFilm(root) {
    root.querySelectorAll('[data-daughter-story]').forEach(section => {
      if (section.dataset.filmReady) return;
      section.dataset.filmReady = 'true';
      const video = section.querySelector('[data-daughter-video]');
      const button = section.querySelector('[data-daughter-toggle]');
      const label = section.querySelector('[data-daughter-label]');
      const status = section.querySelector('[data-daughter-status]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false, userStarted = false, visible = false;
      button.hidden = false;
      function update() {
        const playing = !video.paused && !video.ended;
        label.textContent = playing ? 'Pause video' : 'Play video';
        button.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
      }
      function load() { if (!video.getAttribute('src')) video.src = video.dataset.src; }
      function play() {
        load(); status.textContent = '';
        video.play().catch(() => { update(); });
      }
      function sync() {
        if (visible && !document.hidden && !userPaused && (!motion.matches || userStarted)) play();
        else video.pause();
      }
      video.addEventListener('playing', () => { video.classList.add('is-playing'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { video.classList.remove('is-playing'); userPaused = true; status.textContent = 'Video unavailable. You can still read our story.'; update(); });
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; userStarted = true; play(); }
        else { userPaused = true; video.pause(); }
      });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0.15});
      observer.observe(section);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', () => { userStarted = false; sync(); });
      update();
    });
  }
  initFamilyFilm(document);
  document.addEventListener('shopify:section:load', event => initFamilyFilm(event.target));
})();
